module.exports = __webpack_public_path__ + "static/media/story_05.befca767.jpg";